import { fetchAuthSession } from 'aws-amplify/auth'

export interface TokenProvider {
  getAccessToken(): Promise<string | null>
  refreshAccessToken(): Promise<string | null>
}

async function readAccessToken(forceRefresh: boolean): Promise<string | null> {
  try {
    const session = await fetchAuthSession(forceRefresh ? { forceRefresh: true } : undefined)
    return session.tokens?.accessToken.toString() ?? null
  } catch {
    return null
  }
}

export const amplifyTokenProvider: TokenProvider = {
  getAccessToken: () => readAccessToken(false),
  refreshAccessToken: () => readAccessToken(true),
}
